import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { InfoCircleOutlined, CompassOutlined } from '@ant-design/icons';
import { getYachtsData } from './lib/api';
import { API_BASE_URL } from './lib/constans';
import { useNavigate } from 'react-router-dom';

export default function YachtBanner() {
    const [yatesData, setYatesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hoveredId, setHoveredId] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        const fetchYachts = async () => {
            try {
                const data = await getYachtsData();
                setYatesData(data || []);
            } catch (error) {
                console.error('Error fetching yachts:', error);
                setYatesData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchYachts();
    }, []);

    return (
        <div className="w-full h-full bg-slate-950 flex justify-center items-center">
            {loading ? (
                <div className="text-white text-center">
                    <p className="text-xl">Cargando yates...</p>
                </div>
            ) : yatesData.length === 0 ? (
                <div className="text-white text-center">
                    <p className="text-xl">No hay yates disponibles</p>
                </div>
            ) : (
                <div className="flex w-full h-full gap-4">
                    {yatesData?.map((yate) => {
                        // Si no hay hover, todos miden igual. Si hay hover, el activo se agranda y los otros se achican.
                        const isHovered = hoveredId === yate.id;
                        const isAnyHovered = hoveredId !== null;

                        let flexValue = "flex-1";
                        if (isAnyHovered) {
                            flexValue = isHovered ? "flex-[2.5]" : "flex-[0.5]";
                        }

                        return (
                            <motion.div
                                key={yate.id}
                                onClick={() => navigate(`/${yate.code}`)}
                                className={`relative h-full overflow-hidden cursor-pointer ${flexValue} bg-cover bg-center`}
                                style={{ backgroundImage: `url(${API_BASE_URL + yate.image})` }}
                                onMouseEnter={() => setHoveredId(yate.id)}
                                onMouseLeave={() => setHoveredId(null)}
                                layout // Framer Motion se encarga de animar el cambio de flex de forma fluida
                                transition={{ type: "spring", stiffness: 150, damping: 20 }}
                            >
                                {/* Capa oscura superior */}
                                <div className={`absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent transition-opacity duration-500 ${isHovered ? 'opacity-50' : 'opacity-80'}`} />

                                {/* Contenido del Yate */}
                                <div className="absolute bottom-0 left-0 w-full p-6 text-white z-10 overflow-hidden flex flex-col justify-end min-h-[150px]">

                                    {/* Título (Siempre visible, pero le metemos un icono de Antd al lado si está abierto) */}
                                    <div className="flex items-center gap-2">
                                        {isHovered && <CompassOutlined className="text-amber-400 text-xl animate-pulse" />}
                                        <h3 className="text-xl md:text-4xl font-bold uppercase tracking-wider whitespace-nowrap">
                                            {yate.name}
                                        </h3>
                                    </div>

                                    {/* Detalles (Solo aparecen fluidos con Framer Motion cuando se expande) */}
                                    {isHovered && (
                                        <motion.div
                                            initial={{ opacity: 0, y: 15 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.1, duration: 0.3 }}
                                            className="mt-2 text-sm text-slate-300 flex items-center gap-2 whitespace-nowrap"
                                        >
                                            <InfoCircleOutlined className="text-slate-400" />
                                            <span>{yate.text}</span>
                                        </motion.div>
                                    )}
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}